<div class="footer-bg">
		&copy; {{year}} Luna Solutions &nbsp; <a routerLink="/faq">FAQ</a>  &nbsp;
		<a routerLink="/toc">Website Terms &amp; Conditions</a> &nbsp;
		<a href="https://luna.io/terms/fulfillment/" target="_blank">General Terms &amp; Conditions</a> &nbsp;
		<a routerLink="/privacy">Privacy Policy</a> &nbsp;
</div>
